import { MEDIA_QUERIES } from "@constants"
import styled from "styled-components"

export const PricingTableFeaturesDIV = styled.div`
  margin-bottom: var(--spacing--M);
  transition: box-shadow 0.3s;

  /* START CATEGORY HEADER */
  .category-header {
    padding: var(--spacing--XS) 0;
    border-bottom: 1px solid var(--color--charcoal-200);

    h4 {
      margin-bottom: var(--spacing--M);

      ${MEDIA_QUERIES.L} {
        margin-bottom: var(--headline-medium-L--margin-bottom);
      }
    }

    .grid {
      align-items: center;
    }

    .plans {
      gap: var(--spacing--base-0-75);
    }

    .plan {
      flex: 0 0 calc(33.3333% - var(--spacing--base-0-75) * 2 / 3);
      display: flex;
      flex-direction: column;
      justify-content: center;

      h6 {
        text-align: center;
      }
    }
  }
`
